<template>

  <div>
    <b-overlay :show="overlay">
      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group class="mr-1">
                  <b-form-input
                      v-model="searchInputValue"
                      class="d-inline-block"
                      placeholder="Pesquisar por código, nome ou e-mail..."
                      @keyup.enter="handleSearch"
                  />
                  <b-input-group-append>
                    <b-button :disabled="overlay" @click="clearSearch" variant="outline-danger">
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                    <b-button :disabled="overlay" @click="handleSearch" variant="outline-primary">
                      <feather-icon icon="SearchIcon"/>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-button
                    variant="primary"
                    @click="$bvModal.show('modal-criar-representante')"
                >
                  <div class="d-flex align-items-center" style="gap: 5px">
                    <feather-icon icon="PlusIcon"/>
                    <span>Novo</span>
                  </div>
                </b-button>
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refRepresentanteListTable"
            class="position-relative"
            :items="fetchRepresentante"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(representanteativo)="data">
            <span>{{ data.item.representanteativo ? 'Sim' : 'Não' }}</span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="gradient-primary"
                  title="Visualizar"
                  class="btn-icon mr-1"
                  @click="openEditModal(data.item)"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>

  <!--            <b-button-->
  <!--                variant="gradient-danger"-->
  <!--                class="btn-icon"-->
  <!--                @click="openModalDeleteCustomField(data.item)"-->
  <!--            >-->
  <!--              <feather-icon icon="TrashIcon"/>-->
  <!--            </b-button>-->
            </div>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{
                  dataMeta.of
                }} entradas</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRepresentante"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <ModalCriarRepresentante @criado="onRepresentanteCriado" />

    <ModalAdd
        idModal="modal-add-representante"
        titleModal="Visualizar Representante"
        labelBtnOk="Fechar"
        v-model="dataRepresentante"
        @cancel="resetFormData()"
    />

    <modal-confirmation
        v-model="isDeleteModal"
        id-modal="modal-delete-representante"
        title="Deletar Representante"
        btn-cancel-label="Cancelar"
        btn-ok-label="Sim, deletar"
        @ok="handleRemover(deletedCustomField.representanteid)"
        @cancel="resetFormData()"
    >
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa Representante?</p>
        </div>
      </template>
    </modal-confirmation>

  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ModalAdd from './ModalAdd.vue';
import ModalCriarRepresentante from './ModalCriarRepresentante.vue';
import useList from './useList';

export default {
  components: {
    ModalAdd,
    ModalCriarRepresentante,
    BAvatar,
    BLink,
    BMedia,
    ModalConfirmation,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      isDeleteModal: false,
      deletedCustomField: {
        representanteid: null,
        representantenome: '',
        representanteemail: '',
      },
      searchInputValue: '',
    };
  },
  methods: {
    applyGlobalSearchQuery() {
      const q = this.$route?.query?.q;
      if (!q) return;
      const value = Array.isArray(q) ? q[0] : q;
      this.searchInputValue = value;
      this.searchQuery = value;
    },
    handleRemover(id) {
      this.removerData(id);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Representante deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataRepresentante = data;
      this.$bvModal.show('modal-add-representante');
    },
    resetFormData() {
      this.deletedCustomField = {
        representanteid: null,
        representantenome: '',
        representanteemail: '',
      };
      this.dataRepresentante = {
        representanteid: null,
        representantenome: '',
        representanteemail: '',
      };
      this.isDeleteModal = false;
    },
    onRepresentanteCriado() {
      if (this.$refs.refRepresentanteListTable) {
        this.$refs.refRepresentanteListTable.refresh();
      }
    },
    handleSearch() {
      this.searchQuery = this.searchInputValue;
    },
    clearSearch() {
      this.searchQuery = '';
      this.searchInputValue = '';
    },
  },
  setup() {
    const customFields = ref([]);
    const dataRepresentante = ref({
      representanteid: null,
      representantenome: '',
      representanteemail: '',
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);

    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      perPage,
      currentPage,
      totalRepresentante,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refRepresentanteListTable,
      fetchRepresentante,
      overlay,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      createOrUpdated,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,
      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      currentTab,
      dataRepresentante,
      typeOptionsCustomFields,
      customFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalRepresentante,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchRepresentante,
      overlay,
      tableColumns,
      refRepresentanteListTable,
      createOrUpdated,
      removerData,
    };
  },
  created() {
    this.applyGlobalSearchQuery();
  },
  watch: {
    '$route.query.q': function () {
      this.applyGlobalSearchQuery();
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
